var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

/*!
 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images or videos, 
 * @date: 20-08-2020 14:0:14, 
 * @version: 5.6.2,
 * @link: https://simpleparallax.com/
 */
!function (t, e) {
  exports = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) n.d(i, r, function (e) {
        return t[e];
      }.bind(null, r));
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
  }([function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return x;
    });

    var i = function () {
      return Element.prototype.closest && "IntersectionObserver" in window;
    };

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var s = new (function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this || _global, t), (this || _global).positions = {
          top: 0,
          bottom: 0,
          height: 0
        };
      }

      var e, n, i;
      return e = t, (n = [{
        key: "setViewportTop",
        value: function (t) {
          return (this || _global).positions.top = t ? t.scrollTop : window.pageYOffset, (this || _global).positions;
        }
      }, {
        key: "setViewportBottom",
        value: function () {
          return (this || _global).positions.bottom = (this || _global).positions.top + (this || _global).positions.height, (this || _global).positions;
        }
      }, {
        key: "setViewportAll",
        value: function (t) {
          return (this || _global).positions.top = t ? t.scrollTop : window.pageYOffset, (this || _global).positions.height = t ? t.clientHeight : document.documentElement.clientHeight, (this || _global).positions.bottom = (this || _global).positions.top + (this || _global).positions.height, (this || _global).positions;
        }
      }]) && r(e.prototype, n), i && r(e, i), t;
    }())(),
        o = function (t) {
      return NodeList.prototype.isPrototypeOf(t) || HTMLCollection.prototype.isPrototypeOf(t) ? Array.from(t) : "string" == typeof t || t instanceof String ? document.querySelectorAll(t) : [t];
    },
        a = function () {
      for (var t, e = "transform webkitTransform mozTransform oTransform msTransform".split(" "), n = 0; void 0 === t;) t = void 0 !== document.createElement("div").style[e[n]] ? e[n] : void 0, n += 1;

      return t;
    }(),
        l = function (t) {
      return "img" !== t.tagName.toLowerCase() && "picture" !== t.tagName.toLowerCase() || !!t && !!t.complete && (void 0 === t.naturalWidth || 0 !== t.naturalWidth);
    };

    function u(t) {
      return function (t) {
        if (Array.isArray(t)) return c(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return c(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(t, e);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function c(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];

      return i;
    }

    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var f = function () {
      function t(e, n) {
        var i = this || _global;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this || _global, t), (this || _global).element = e, (this || _global).elementContainer = e, (this || _global).settings = n, (this || _global).isVisible = !0, (this || _global).isInit = !1, (this || _global).oldTranslateValue = -1, (this || _global).init = (this || _global).init.bind(this || _global), (this || _global).customWrapper = (this || _global).settings.customWrapper && (this || _global).element.closest((this || _global).settings.customWrapper) ? (this || _global).element.closest((this || _global).settings.customWrapper) : null, l(e) ? this.init() : (this || _global).element.addEventListener("load", function () {
          setTimeout(function () {
            i.init(!0);
          }, 50);
        });
      }

      var e, n, i;
      return e = t, (n = [{
        key: "init",
        value: function (t) {
          var e = this || _global;
          (this || _global).isInit || (t && ((this || _global).rangeMax = null), (this || _global).element.closest(".simpleParallax") || (!1 === (this || _global).settings.overflow && this.wrapElement((this || _global).element), this.setTransformCSS(), this.getElementOffset(), this.intersectionObserver(), this.getTranslateValue(), this.animate(), (this || _global).settings.delay > 0 ? setTimeout(function () {
            e.setTransitionCSS(), e.elementContainer.classList.add("simple-parallax-initialized");
          }, 10) : (this || _global).elementContainer.classList.add("simple-parallax-initialized"), (this || _global).isInit = !0));
        }
      }, {
        key: "wrapElement",
        value: function () {
          var t = (this || _global).element.closest("picture") || (this || _global).element,
              e = (this || _global).customWrapper || document.createElement("div");

          e.classList.add("simpleParallax"), e.style.overflow = "hidden", (this || _global).customWrapper || (t.parentNode.insertBefore(e, t), e.appendChild(t)), (this || _global).elementContainer = e;
        }
      }, {
        key: "unWrapElement",
        value: function () {
          var t = (this || _global).elementContainer;
          (this || _global).customWrapper ? (t.classList.remove("simpleParallax"), t.style.overflow = "") : t.replaceWith.apply(t, u(t.childNodes));
        }
      }, {
        key: "setTransformCSS",
        value: function () {
          !1 === (this || _global).settings.overflow && ((this || _global).element.style[a] = "scale(".concat((this || _global).settings.scale, ")")), (this || _global).element.style.willChange = "transform";
        }
      }, {
        key: "setTransitionCSS",
        value: function () {
          (this || _global).element.style.transition = "transform ".concat((this || _global).settings.delay, "s ").concat((this || _global).settings.transition);
        }
      }, {
        key: "unSetStyle",
        value: function () {
          (this || _global).element.style.willChange = "", (this || _global).element.style[a] = "", (this || _global).element.style.transition = "";
        }
      }, {
        key: "getElementOffset",
        value: function () {
          var t = (this || _global).elementContainer.getBoundingClientRect();

          if ((this || _global).elementHeight = t.height, (this || _global).elementTop = t.top + s.positions.top, (this || _global).settings.customContainer) {
            var e = (this || _global).settings.customContainer.getBoundingClientRect();

            (this || _global).elementTop = t.top - e.top + s.positions.top;
          }

          (this || _global).elementBottom = (this || _global).elementHeight + (this || _global).elementTop;
        }
      }, {
        key: "buildThresholdList",
        value: function () {
          for (var t = [], e = 1; e <= (this || _global).elementHeight; e++) {
            var n = e / (this || _global).elementHeight;
            t.push(n);
          }

          return t;
        }
      }, {
        key: "intersectionObserver",
        value: function () {
          var t = {
            root: null,
            threshold: this.buildThresholdList()
          };
          (this || _global).observer = new IntersectionObserver((this || _global).intersectionObserverCallback.bind(this || _global), t), (this || _global).observer.observe((this || _global).element);
        }
      }, {
        key: "intersectionObserverCallback",
        value: function (t) {
          var e = this || _global;
          t.forEach(function (t) {
            t.isIntersecting ? e.isVisible = !0 : e.isVisible = !1;
          });
        }
      }, {
        key: "checkIfVisible",
        value: function () {
          return (this || _global).elementBottom > s.positions.top && (this || _global).elementTop < s.positions.bottom;
        }
      }, {
        key: "getRangeMax",
        value: function () {
          var t = (this || _global).element.clientHeight;
          (this || _global).rangeMax = t * (this || _global).settings.scale - t;
        }
      }, {
        key: "getTranslateValue",
        value: function () {
          var t = ((s.positions.bottom - (this || _global).elementTop) / ((s.positions.height + (this || _global).elementHeight) / 100)).toFixed(1);
          return t = Math.min(100, Math.max(0, t)), 0 !== (this || _global).settings.maxTransition && t > (this || _global).settings.maxTransition && (t = (this || _global).settings.maxTransition), (this || _global).oldPercentage !== t && ((this || _global).rangeMax || this.getRangeMax(), (this || _global).translateValue = (t / 100 * (this || _global).rangeMax - (this || _global).rangeMax / 2).toFixed(0), (this || _global).oldTranslateValue !== (this || _global).translateValue && ((this || _global).oldPercentage = t, (this || _global).oldTranslateValue = (this || _global).translateValue, !0));
        }
      }, {
        key: "animate",
        value: function () {
          var t,
              e = 0,
              n = 0;
          ((this || _global).settings.orientation.includes("left") || (this || _global).settings.orientation.includes("right")) && (n = "".concat((this || _global).settings.orientation.includes("left") ? -1 * (this || _global).translateValue : (this || _global).translateValue, "px")), ((this || _global).settings.orientation.includes("up") || (this || _global).settings.orientation.includes("down")) && (e = "".concat((this || _global).settings.orientation.includes("up") ? -1 * (this || _global).translateValue : (this || _global).translateValue, "px")), t = !1 === (this || _global).settings.overflow ? "translate3d(".concat(n, ", ").concat(e, ", 0) scale(").concat((this || _global).settings.scale, ")") : "translate3d(".concat(n, ", ").concat(e, ", 0)"), (this || _global).element.style[a] = t;
        }
      }]) && h(e.prototype, n), i && h(e, i), t;
    }();

    function m(t) {
      return function (t) {
        if (Array.isArray(t)) return y(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || d(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function p(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
            i = !0,
            r = !1,
            s = void 0;

        try {
          for (var o, a = t[Symbol.iterator](); !(i = (o = a.next()).done) && (n.push(o.value), !e || n.length !== e); i = !0);
        } catch (t) {
          r = !0, s = t;
        } finally {
          try {
            i || null == a.return || a.return();
          } finally {
            if (r) throw s;
          }
        }

        return n;
      }(t, e) || d(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function d(t, e) {
      if (t) {
        if ("string" == typeof t) return y(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(t, e) : void 0;
      }
    }

    function y(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];

      return i;
    }

    function v(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var g,
        b,
        w = !1,
        T = [],
        x = function () {
      function t(e, n) {
        if (function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this || _global, t), e && i()) {
          if ((this || _global).elements = o(e), (this || _global).defaults = {
            delay: 0,
            orientation: "up",
            scale: 1.3,
            overflow: !1,
            transition: "cubic-bezier(0,0,0,1)",
            customContainer: "",
            customWrapper: "",
            maxTransition: 0
          }, (this || _global).settings = Object.assign((this || _global).defaults, n), (this || _global).settings.customContainer) {
            var r = p(o((this || _global).settings.customContainer), 1);
            (this || _global).customContainer = r[0];
          }

          (this || _global).lastPosition = -1, (this || _global).resizeIsDone = (this || _global).resizeIsDone.bind(this || _global), (this || _global).refresh = (this || _global).refresh.bind(this || _global), (this || _global).proceedRequestAnimationFrame = (this || _global).proceedRequestAnimationFrame.bind(this || _global), this.init();
        }
      }

      var e, n, r;
      return e = t, (n = [{
        key: "init",
        value: function () {
          var t = this || _global;
          s.setViewportAll((this || _global).customContainer), T = [].concat(m((this || _global).elements.map(function (e) {
            return new f(e, t.settings);
          })), m(T)), w || (this.proceedRequestAnimationFrame(), window.addEventListener("resize", (this || _global).resizeIsDone), w = !0);
        }
      }, {
        key: "resizeIsDone",
        value: function () {
          clearTimeout(b), b = setTimeout((this || _global).refresh, 200);
        }
      }, {
        key: "proceedRequestAnimationFrame",
        value: function () {
          var t = this || _global;
          s.setViewportTop((this || _global).customContainer), (this || _global).lastPosition !== s.positions.top ? (s.setViewportBottom(), T.forEach(function (e) {
            t.proceedElement(e);
          }), g = window.requestAnimationFrame((this || _global).proceedRequestAnimationFrame), (this || _global).lastPosition = s.positions.top) : g = window.requestAnimationFrame((this || _global).proceedRequestAnimationFrame);
        }
      }, {
        key: "proceedElement",
        value: function (t) {
          ((this || _global).customContainer ? t.checkIfVisible() : t.isVisible) && t.getTranslateValue() && t.animate();
        }
      }, {
        key: "refresh",
        value: function () {
          s.setViewportAll((this || _global).customContainer), T.forEach(function (t) {
            t.getElementOffset(), t.getRangeMax();
          }), (this || _global).lastPosition = -1;
        }
      }, {
        key: "destroy",
        value: function () {
          var t = this || _global,
              e = [];
          T = T.filter(function (n) {
            return t.elements.includes(n.element) ? (e.push(n), !1) : n;
          }), e.forEach(function (e) {
            e.unSetStyle(), !1 === t.settings.overflow && e.unWrapElement();
          }), T.length || (window.cancelAnimationFrame(g), window.removeEventListener("resize", (this || _global).refresh), w = !1);
        }
      }]) && v(e.prototype, n), r && v(e, r), t;
    }();
  }]).default;
});
export default exports;
export const simpleParallax = exports.simpleParallax;